import { Inject, Injectable } from '@angular/core';
import {CRUD_FORM__QUERY_SERVICE_INSTANCE, CRUD_FORM_ENDPOINT, GET_DATA_FORM_ENDPOINT} from '../survey.config';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from '../../../../core/services/snackbar-psa.service';  // Import MatSnackBar
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { SurveySaveForm } from '../models/crud-survey.model';


@Injectable({
  providedIn: 'root'
})
export class SurveyCrudFormService extends CrudService<SurveySaveForm> {

  constructor(
    @Inject(CRUD_FORM__QUERY_SERVICE_INSTANCE) public readonly query: QueryService<SurveySaveForm>,
    public readonly apiService:ApiService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(CRUD_FORM_ENDPOINT, apiService, snackbar);
  }

 get<SurveySaveForm>(id:string, tipoForm:string){
  return this.apiService.get<SurveySaveForm>(`${CRUD_FORM_ENDPOINT}?id=${id}&tipoForm=${tipoForm}`)
  }

  getFormData<SurveySaveForm>(idPsa:string, tipoForm:string){
    return this.apiService.get<SurveySaveForm>(`${GET_DATA_FORM_ENDPOINT}?idPsa=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  }

  countElementInForm<SurveySaveForm>(idPsa:string, tipoForm:string){
    return this.apiService.get<SurveySaveForm>(`${CRUD_FORM_ENDPOINT}/count?idPsa=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  }

  getPreviousNominativiInForm(idPsa:string, tipoForm:string){
    return this.apiService.get<any>(`${CRUD_FORM_ENDPOINT}/nominativi?idPsa=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  }


  getPreviousFormData<SurveySaveForm>(idPsa:string, tipoForm:string){
    return this.apiService.get<SurveySaveForm>(`${CRUD_FORM_ENDPOINT}?id=${idPsa}&tipoForm=${tipoForm}`, 0, true)
  }
}
